var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true}}],staticClass:"cms-content cms-style",domProps:{"innerHTML":_vm._s(_vm.cmsHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }